<template>
  <div class="label-row d-flex align-center justify-space-between">
    <label class="form-label-text">{{ label }}</label>
  </div>
</template>

<script setup>
defineProps({
  label: {
    type: String,
    default: '',
  },
});
</script>

<style lang="less" scoped>
.label-row {
  width: 100%;
}
</style>
